import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import AirportsTable from "../../components/airports/AirportsTable";

const Airports = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <AirportsTable />
        </WrapperSection>
    );
};

export default Airports;
